import { useRef } from "react";
import { useIsomorphicLayoutEffect } from "./use-isomorphic-layout-effect";

export function useScheduleUpdate(deps = []) {
  const scheduleUpdateRef = useRef(null);
  useIsomorphicLayoutEffect(
    () => () => {
      if (scheduleUpdateRef.current) {
        scheduleUpdateRef.current();
      }
    },
    deps
  );
  return scheduleUpdateRef;
}
